import { ProductInput } from '@/models/Import'
import DataService from '@/services/DataService'
import { useTranslation } from './useTranslation'

export const useBarcodes = () => {
  const { appTranslate } = useTranslation()

  /**
   * Checks for collisions with existing codes and duplicates among the edited products
   * @returns true if ok, false otherwise
   */
  const checkBarcodeCollisions = async (products: ProductInput[]) => {
    const barcodeCollisions = await DataService.getBarcodeCollisions(products)
    if (barcodeCollisions.collisionsWithExisting?.length || barcodeCollisions.duplicatesInEdit?.length) {
      const collisionsWithExistingMsg = barcodeCollisions.collisionsWithExisting?.length
        ? appTranslate('Some barcodes in your edit already exists:\n%s', [barcodeCollisions.collisionsWithExisting.join(', ')])
        : undefined
      const duplicatesInEditMsg = barcodeCollisions.duplicatesInEdit?.length
        ? appTranslate('Found duplicate barcodes in your edit:\n%s', [barcodeCollisions.duplicatesInEdit.join(', ')])
        : undefined
      const msg = [appTranslate('Warning!'), collisionsWithExistingMsg, duplicatesInEditMsg, appTranslate('Do you want to proceed?')]
        .filter(Boolean)
        .join('\n\n')

      return { msg, ok: false }
    }

    return { ok: true }
  }

  return { checkBarcodeCollisions }
}
